import { Fragment } from "react";
import DashboardSiderbar from "../dashboard/DashboardSiderbar";
import "./Layout.css";

const Layout = (props) => {
  return (
    <Fragment>
      <div className="wrapper">
        <DashboardSiderbar />
        <main className="main">{props.children}</main>
      </div>
    </Fragment>
  );
};

export default Layout;
